<template>
  <span>
    <Button label="Start" @click="start"/>
    <Button label="Stop"  @click="stop"/>
    fps (min): {{fixed(fpsMin,2)}}, fps (max): {{fixed(fpsMax,2)}}, fps: {{fixed(fps,2)}}
  </span>
  <Ball/>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import Ball   from './components/Ball.vue'
import Button from './components/form/Button.vue'

import fixed  from '/mixins/fixed'

export default
{ name: 'App',

  mixins: [fixed],

  components: 
  { Ball,
    Button,
  },

  computed:
  { ...mapState('gameloop', ['fps', 'fpsMin', 'fpsMax']) },

  methods:
  { ...mapActions('gameloop', ['start', 'stop']) },

  mounted()
  { this.start() },
}
</script>

<style>
body
{ font-size:        3vw;
  font-family:      Verdana, Helvetica, sans-serif;
  background-color: #C5EF00;
}

input
{ font-size:  100%;
  display:    inline-block;
  box-sizing: border-box;
  margin:     0.5ex;
}
</style>
